export default __webpack_public_path__ + "static/media/logon.ca069059.png";